/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { EntityFieldItemEdit } from "./edit-item";

const EntityFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <EntityFieldItemEdit />
        </FieldListEditWrapper>
    );
};
EntityFieldEdit.displayName = "EntityFieldEdit";
export { EntityFieldEdit };
